import React, { FC } from 'react';
import { IRequiredIdentify } from '@src/models/analytics';
import { IDefaultComponentProps, ILinkComponent } from '@src/models/props';
import { Link } from '../Link';
import { IDefaultLinkProps } from '../models';

interface IProps extends IDefaultComponentProps, ILinkComponent, IDefaultLinkProps, IRequiredIdentify {}
/**
 * Мы часто сталкиваемся с тем что необходимо навесить ссылку на какой либо компонент (Кнопка, текст, карточка продукта...).
 * Это универсальный компонент который может обернуть любой из дочерних компонентов в обертку с ссылкой
 * или как в случае с проектами на NextJS, обернуть в специальный компонент ссылку, который передает корректный урл.
 *
 * !!! При этом на обертку не вешается каких-либо дополнительный обработчиков или атрибутов или статистики !!!
 * Вся реализация должна быть внутри дочернего компонента
 *  */
export const LinkWrapper: FC<IProps> = (props) => {
  if (props.href) {
    return <Link {...props} />;
  }

  return <>{props.children}</>;
};

LinkWrapper.displayName = 'LinkWrapper';
